<template>
  <div>
    <v-row class="my-3" dense>

      <v-col cols="1"
             class="ml-5 mt-9"
      >
        <v-card elevation="0">
          <v-icon color="primary"
                  x-large
                  class="mt-2 ml-2 center"
          >
            mdi-folder-zip
          </v-icon>
        </v-card>
      </v-col>

      <v-col>
        <v-list-item three-line>
          <v-list-item-content>

            <v-row>
              <v-col class="mt-1 font-weight-medium pb-0">
                {{scorm.originalName}}
              </v-col>
            </v-row>

            <v-row class="mt-0">
              <v-chip small outlined class="ml-3 mt-0">
                Scorm ID:  {{scorm.courseId}}
              </v-chip>

              <v-chip small outlined class="ml-2">
                ID:  {{scorm._id}}
              </v-chip>
            </v-row>

          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ResourceScorm",
  props: {
    scorm: {
      type: Object,
      required: true,
    },
  },
};
</script>